export default __webpack_public_path__ + "static/media/mlc-invelitori.73836dc8.jpeg";